import { FC, useMemo, memo } from 'react';

import clsx from 'clsx';
import ReactECharts from 'echarts-for-react';

import { WidgetWithTableType } from '@/types';
import { prepareBigWidgetChartOptions } from '@/utils';

import { TableData } from '../TableData';

import styles from './styles.module.scss';

const colorsStatsPalette = {
  yellow: 'rgba(249, 163, 29, 1)',
  green: 'rgba(82, 179, 107, 1)',
  red: 'rgba(244, 106, 117, 1)',
};

const statsColors = {
  yellow: 'rgba(255, 248, 237, 1)',
  green: 'rgba(239, 249, 247, 1)',
  red: 'rgba(254, 242, 243, 1)',
};

export const WidgetBody: FC<{ data: WidgetWithTableType }> = memo(({ data }) => {
  const {
    stats: { color = 'green', statsLabelPrimary, statsLabelSecondary, statsValuePrimary, statsValueSecondary, value },
  } = data;

  const modifiedPieData = useMemo(
    () =>
      data.pieData.map((item) => {
        if (item.name === 'No') {
          return {
            ...item,
            emphasis: {
              itemStyle: {
                color: '#EBEEF2',
              },
            },
          };
        }

        return item;
      }),
    [data.pieData],
  );

  const options = useMemo(
    () => prepareBigWidgetChartOptions(value, modifiedPieData, color || 'green'),
    [value, modifiedPieData, color],
  );

  return (
    <div className={styles.widgetBodyContainer}>
      <div className={clsx(styles.col50, styles.chartWrapper)}>
        <ReactECharts className={styles.chart__wrapper__pie} option={options} />

        <div className={styles.line} />
        <div
          style={{ backgroundColor: statsColors[color] }}
          className={clsx(styles.gauge__stats, styles.gauge__stats__LID)}
        >
          <div className={styles.infoWrapper}>
            <h4 className={styles.gauge__stats__LID__label}>{statsLabelPrimary}</h4>
            <h2 className={styles.gauge__stats__LID__value} style={{ color: colorsStatsPalette[color] }}>
              {statsValuePrimary}
            </h2>
          </div>

          <div className={styles.infoWrapper}>
            <h4 className={styles.gauge__stats__LID__label}>{statsLabelSecondary}</h4>
            <h2 className={styles.gauge__stats__LID__value} style={{ color: colorsStatsPalette[color] }}>
              {statsValueSecondary}
            </h2>
          </div>
        </div>
      </div>

      <div className={styles.col50}>
        <TableData data={data} />
      </div>
    </div>
  );
});

WidgetBody.displayName = 'WidgetBody';
